const ORANGE_POST_PTO = 'OrangePostPTO';
const ORANGE_PRE_PTO = 'OrangePrePTO';

export { ORANGE_POST_PTO, ORANGE_PRE_PTO };
